const NAMESPACE = 'IdleDrivers';

Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck[NAMESPACE] = {

  template() {
    return {
        tag: 'div',
        items: [
              {
                items: [
                    {
                        tag: 'label',
                        items: [
                            {
                                tag: 'span',
                                html: Monet.I18n.getResourcesByKey('event.check.driversCongregation.timeMinutes'),
                                attributes: {
                                    class: 'i18nResource',
                                },
                            },
                        ],
                        attributes: {
                            class: 'control-label',
                            for: 'drivers_congregation_time_minutes',
                        },
                    },
                    {
                        tag: 'input',
                        attributes: {
                            type: 'text',
                            name: 'drivers_congregation_time_minutes',
                            maxlength: '4',
                            alt: '',
                            value: '',
                            size: '11',
                            id: 'drivers_congregation_time_minutes',
                            class: 'modelAttribute textField numberPicker mandatory',
                            autocomplete: 'off',
                            oninput: 'this.value = this.value.replace(/\\D/g, "")'
                        },
                    },
                    {
                        tag: 'label',
                        items: [
                            {
                                tag: 'span',
                                html: Monet.I18n.getResourcesByKey('event.check.driversCongregation.radius'),
                                attributes: {
                                    class: 'i18nResource',
                                },
                            },
                        ],
                        attributes: {
                            class: 'control-label',
                            for: 'drivers_congregation_radius',
                        },
                    },
                    {
                        tag: 'input',
                        attributes: {
                            type: 'text',
                            name: 'drivers_congregation_radius',
                            maxlength: '4',
                            alt: '',
                            value: '',
                            size: '11',
                            id: 'drivers_congregation_radius',
                            class: 'modelAttribute textField numberPicker mandatory',
                            autocomplete: 'off',
                            oninput: 'this.value = this.value.replace(/\\D/g, "")'
                        },
                    },
                    {
                        items: [
                            {
                                tag: 'input',
                                attributes: {
                                    type: 'checkbox',
                                    id: 'hos_check_idle',
                                    class: 'modelAttribute checkbox',
                                },
                            },
                            {
                                tag: 'span',
                                html: Monet.I18n.getResourcesByKey('event.check.driversCongregation.hosCheck'),
                                attributes: {
                                    class: 'i18nResource',
                                    style: 'margin-left: 5px'
                                },
                            },

                        ],
                        attributes: {
                            class: 'controls',
                        },
                    },
                    {
                        items: [
                            {
                                tag: 'label',
                                items: [
                                    {
                                        tag: 'span',
                                        html: Monet.I18n.getResourcesByKey('event.check.driversCongregation.hosTypes'),
                                        attributes: {
                                            class: 'i18nResource',
                                            id: 'span-hosTypes_idle',
                                            style: 'display: none'
                                        },
                                    },
                                ],
                                attributes: {
                                    class: 'control-label',
                                    for: 'hosTypes_idle',
                                },
                            },
                            {
                                items: [
                                    {
                                        tag: 'select',
                                        attributes: {
                                            multiple: 'true',
                                            id: 'hosTypes_idle',
                                            style: 'display: none',
                                            required: true
                                        },
                                    },
                                ],
                                attributes: {
                                    class: 'controls',
                                },
                            },
                        ],
                        attributes: {
                            class: 'control-group',
                            style: 'margin-top: 10px'
                        },
                    },
                ],
            }
        ]
    };
  },

  assignParameter(jsonParam) {

    const hosTypesList = [
      Monet.I18n.getResourcesByKey('event.check.driversCongregation.hosType.startBreak'),
      Monet.I18n.getResourcesByKey('event.check.driversCongregation.hosType.startLunch'),
    ];

    const hosTypesEnum = [ "BREAK_START", "LUNCH_START"];

    const checkbox = document.querySelector('#hos_check_idle');
    const select = document.querySelector('#hosTypes_idle');
    const span = document.querySelector('#span-hosTypes_idle');

    const appendHosType = (hosTypeListIndex, hosType, isSelected) => {
        const newOption = new Option(hosTypeListIndex, hosType, false, isSelected);
        $('#hosTypes_idle').append(newOption);
    };

    if (jsonParam) {
        const timeMinutesEl = document.getElementById('drivers_congregation_time_minutes');
        const radius = document.getElementById('drivers_congregation_radius');

        const { timeMinutes, driverRadius, hosChecked, hosTypes } = JSON.parse(jsonParam);

        timeMinutesEl.value = timeMinutes;
        radius.value = driverRadius;
        checkbox.checked = hosChecked;

        const hosTypesSelected = hosTypes;

        if(checkbox.checked) {
            select.style.display = 'block';
            span.style.display = 'block';
        } else {
            select.style.display = 'none';
            span.style.display = 'none';
        }
        let isSelected;

        hosTypesEnum.forEach((hos, index) => {
            if (hosTypesSelected?.length) {
                isSelected = hosTypesSelected.some(itemSelected => itemSelected === hos);
                appendHosType(hosTypesList[index], hos, isSelected);
            } else {
                appendHosType(hosTypesList[index], hos, false);
            }
        });
    } else {
        for (let x = 0; x < hosTypesEnum.length; x++) {
            appendHosType(hosTypesList[x], hosTypesEnum[x], false);
        }
    }

    checkbox.addEventListener('click', (event) => {
       if(event.target.checked) {
         select.style.display = 'block';
         span.style.display = 'block';
       } else {
         select.style.display = 'none';
         span.style.display = 'none';

         let hosTypes = $('#hosTypes_idle option');

         for(let i = 0; i < hosTypes.length; i++) {
             hosTypes[i].selected = false;
         }
       }
    });
  },

  retrieveParameter() {
    const timeMinutes = parseInt($('#drivers_congregation_time_minutes').val(), 10);
    const driverRadius = parseInt($('#drivers_congregation_radius').val(), 10);
    const checkbox = document.querySelector('#hos_check_idle').checked;

    const hosTypesSelected = [];
    const hosTypesSize = $('#hosTypes_idle option:selected').length;
    let item = 0;

    for (let x = 0; x < hosTypesSize; x++) {
      const value = $('#hosTypes_idle option:selected')[x].value;


      if (value) {
          hosTypesSelected[item] = value;
          item++;
      }
    }

    return JSON.stringify({
      timeMinutes: timeMinutes,
      driverRadius: driverRadius,
      hosChecked: checkbox,
      hosTypes: hosTypesSelected
    });
  }
};
